import { onReady } from '../lib/on-ready.js';

function initSectionTitle() {
    document.querySelectorAll('.bigtext').forEach((bigtext) => {
        const bigtextContent = bigtext.querySelector('.bigtext-content');
        if (!bigtextContent) {
            return;
        }

        const textCount = bigtextContent.innerText.length;
        if (textCount < 12) {
            bigtextContent.style.fontSize = '14vw';
            return;
        }

        let textSize = 14 - (textCount * 0.3);
        if (textSize < 5) {
            textSize = 5;
        }
        bigtextContent.style.fontSize = `${textSize}vw`;
    });
}

onReady(initSectionTitle);
